module.exports = __webpack_public_path__ + "img/va.080d55e2.svg";